// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"aef16e27","298":"c5975744","453":"5ab89727","888":"fd18f0e6"}[chunkId] + ".chunk.js";
};